import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Loader } from "arv-reactcomponents";
import StoresListView from "./StoresListView";

class StoreListModal extends Component {
  componentDidMount() {
    console.log(this);
  }
  render() {
    const {
      data,
      isOpen,
      onClose,
      className,
      loading,
      selectStore,
      pincode,
    } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        className={`${className} nw-storelistmodal`}
      >
        {loading && (
          <div className="nw-storelistmodal-loading nwc-translucentbackground-white">
            <Loader />
          </div>
        )}
        <StoresListView.component
          data={data}
          selectStore={selectStore}
          pincode={pincode}
        />
      </Modal>
    );
  }
}

StoreListModal.defaultProps = {
  className: "",
  loading: false,
  isOpen: false,
  selectStore: null,
  pincode: "",
};

StoreListModal.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  selectStore: PropTypes.func,
  pincode: PropTypes.string,
};

export { default as StoresListView } from "./StoresListView";

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoreListModal,
  component: StoreListModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StoreListModal/index.js